(() => {
  angular
    .module('app')
    .controller(
      'host.views.corporates.createEdit.collateral.collateralHistory',
      CollateralHistoryModalController
    );

  CollateralHistoryModalController.$inject = [
    '$uibModalInstance',
    'moment',
    'abp.services.app.collateralEpisode',
    'Hms.MultiTenancy.CollateralType',
    'corporateId',
    'currencyCode',
  ];

  function CollateralHistoryModalController(
    $uibModalInstance,
    moment,
    collateralEpisodeSvc,
    enumCollateralType,
    corporateId,
    currencyCode
  ) {
    const vm = this;

    // Same type colours as the Collateral tab.

    const typeLabelClasses = {
      [enumCollateralType.Escrow.id]: 'label-success',
      [enumCollateralType.BankGuarantee.id]: 'label-info',
      [enumCollateralType.DirectDebit.id]: 'label-warning',
    };

    vm.loading = 0;
    vm.currencyCode = currencyCode;
    vm.totalAmount = 0;
    vm.items = [];

    vm.getTypeName = getTypeName;
    vm.getTypeLabelClass = getTypeLabelClass;
    vm.isExpired = isExpired;
    vm.cancel = cancel;

    init();

    function init() {
      getCollateralEpisodeHistory();
    }

    // Every episode, closed and active, already newest first. The total counts active ones only.

    function getCollateralEpisodeHistory() {
      vm.loading += 1;
      collateralEpisodeSvc
        .getCollateralEpisodeHistory({ id: corporateId })
        .success((data) => {
          vm.totalAmount = data.totalAmount;
          vm.items = data.items;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getTypeName(collateralType) {
      const type = _.find(enumCollateralType.values, { id: collateralType });
      return type ? type.name : '';
    }

    function getTypeLabelClass(collateralType) {
      return typeLabelClasses[collateralType] || 'label-default';
    }

    // An active Bank Guarantee past its expiry date still counts until Finance closes it; the badge
    // only flags it, as on the Collateral tab.

    function isExpired(item) {
      return (
        item.isActive &&
        item.collateralType === enumCollateralType.BankGuarantee.id &&
        !!item.expiryDate &&
        App.getLocalDate(item.expiryDate).isBefore(moment().startOf('day'))
      );
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
